import { Component, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TermsOfServicePage } from "../../../app/terms-of-service/terms-of-service.page";
import { PrivacyPolicyPage } from "../../../app/privacy-policy/privacy-policy.page";

@Component({
  selector: "app-global-footer",
  templateUrl: "./global-footer.component.html",
  styleUrls: ["./global-footer.component.scss"]
})
export class GlobalFooterComponent implements OnInit {
  constructor(private modalController: ModalController) {}

  ngOnInit() {}

  async showTermsModal() {
    const modal = await this.modalController.create({
      component: TermsOfServicePage
    });
    return await modal.present();
  }

  async showPrivacyModal() {
    const modal = await this.modalController.create({
      component: PrivacyPolicyPage
    });
    return await modal.present();
  }
}
